export default __webpack_public_path__ + "static/media/dash-flex-jobs.533cafce.svg";